import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=57fa96ee&scoped=true&"
import script from "./CategoryDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=57fa96ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa96ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57fa96ee')) {
      api.createRecord('57fa96ee', component.options)
    } else {
      api.reload('57fa96ee', component.options)
    }
    module.hot.accept("./CategoryDialog.vue?vue&type=template&id=57fa96ee&scoped=true&", function () {
      api.rerender('57fa96ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/categoryAssociation/components/CategoryDialog.vue"
export default component.exports